import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "footer-social-links" };
import PButton from 'primevue/button';
import { vDataLink } from '../utils/data-link-directive';
import { vTooltipAccessible } from '../utils/tooltip-directive';
import NamedIcon from './named-icon.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'footer-social-links',
    props: {
        links: { default: () => [{
                    url: 'https://www.instagram.com/curtinlifeaustralia/',
                    iconName: import('../assets/icons/social-instagram.svg').then(p => p.default.id),
                    ariaLabel: 'Visit Curtin Life Instagram page',
                    tooltip: 'Instagram'
                }, {
                    url: 'https://www.youtube.com/@CurtinLifeAustralia',
                    iconName: import('../assets/icons/social-youtube.svg').then(p => p.default.id),
                    ariaLabel: 'Visit Curtin Life YouTube channel',
                    tooltip: 'YouTube'
                }] }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, "default", {}, () => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.links, (link) => {
                        return _withDirectives((_openBlock(), _createBlock(_unref(PButton), {
                            key: link.url,
                            as: "a",
                            severity: "tertiary",
                            rounded: "",
                            href: link.url,
                            title: link.tooltip,
                            "aria-label": link.ariaLabel,
                            rel: "noopener",
                            class: "footer-social-link"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(NamedIcon, {
                                    name: link.iconName,
                                    "aria-hidden": true
                                }, null, 8, ["name"])
                            ]),
                            _: 2
                        }, 1032, ["href", "title", "aria-label"])), [
                            [_unref(vDataLink), { area: 'oasis-footer', category: 'social-link', link }],
                            [
                                _unref(vTooltipAccessible),
                                { value: link.tooltip, autoHide: false },
                                void 0,
                                {
                                    focus: true,
                                    top: true
                                }
                            ]
                        ]);
                    }), 128))
                ])
            ]));
        };
    }
});
